/* Fix: Remove Close Cart Button from Drawer Cart */

// First, disable all existing cart drawer/modal logic
Shopify.CartDrawer = undefined;

// Remove any elements with the close cart class if they exist on load
document.addEventListener("DOMContentLoaded", function () {
  const closeCartButtons = document.querySelectorAll(
    ".ajaxifyCart--close, button[aria-label='Close cart'], button:contains('Close Cart')"
  );

  closeCartButtons.forEach(btn => btn.remove());
});

// If Shopify AJAX cart system is enabled via settings, prevent it from mounting
window.theme = window.theme || {};
window.theme.settings = window.theme.settings || {};
window.theme.settings.cartType = 'page'; // Force fallback to cart page, not drawer or modal

// Optional safety CSS (if you want to inject into <style>)
const style = document.createElement('style');
style.innerHTML = `
  .ajaxifyCart--close,
  button[aria-label='Close cart'],
  button:contains('Close Cart') {
    display: none !important;
  }
`;
document.head.appendChild(style);

// Override any toggleCartButton logic
const cartToggle = document.querySelectorAll('.cart-toggle');
cartToggle.forEach(btn => {
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href = '/cart';
  });
});
